"use client";

import Content from "@/components/common/Layout/Content";
import Footer from "@/components/common/Layout/Footer";
import Header from "@/components/common/Layout/Header";
import { Divider, Layout } from "antd";
import { Suspense } from "react";
import BasicLayoutHeader from "./BasicLayoutHeader";
import NavigationList from "./NavigationList";
import PageLoading from "@/components/common/PageLoading";
import ModalPendingOrders from "./ModalPendingOrders";
import BasicLayoutFooterV1 from "./BasicLayoutFooterV1";

const BaseLayout = ({ children }: any) => {
  return (
    <Layout className="layout">
      <ModalPendingOrders />
      <Header className="layout__header" style={{ zIndex: 2 }}>
        <BasicLayoutHeader />
      </Header>
      <Divider style={{ margin: 0 }} />
      <Content className="layout__content">
        <NavigationList />

        <Suspense fallback={<PageLoading />}>{children}</Suspense>
        <Divider style={{ margin: 0 }} />
        <Footer className="layout__footer">
          <BasicLayoutFooterV1 />
        </Footer>
      </Content>
    </Layout>
  );
};

export default BaseLayout;
